import React, { useState } from "react";

interface UserMenuProps {
  displayName: string;
  isCollapsed: boolean;
  onLogout: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ displayName, isCollapsed, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="user-menu">
      <button className="user-btn" onClick={() => setIsOpen((o) => !o)}>
        <div className="user-avatar">
          <i className="fas fa-user" />
        </div>
        {!isCollapsed && (
          <>
            <span className="user-name">{displayName || "User"}</span>
            <i className="fas fa-ellipsis-h" />
          </>
        )}
      </button>

      {isOpen && !isCollapsed && (
        <div className="user-menu-dropdown">
          <button className="menu-item" onClick={onLogout}>
            <i className="fas fa-sign-out-alt" />
            <span>Log out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;